import {
  OBTENIR_INDRETS,
  OBTENIR_INDRETS_LLISTAT,
  OBTENIR_INDRET_ID,
  OBTENIR_DADES_INDRET,
  ESBORRAR_INDRET_SELECCIONAT,
  INDRET_INICIALITZAR,
  INDRET_INTRODUCCIO_MODIFICAR_CAMP,
  INDRET_INTRODUCCIO_DESCARTAR_CANVIS,
  INDRET_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
  INDRET_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA,
  INDRET_INTRODUCCIO_MOSTRAR_ERRORS,
  INDRET_INTRODUCCIO_FOTOS_CREAR_FOTO,
  INDRET_INTRODUCCIO_FOTOS_ELIMINAR_FOTO,
  INDRET_INTRODUCCIO_FOTOS_DESCARTAR_FOTO,
  CANVI_TEXT_CERCA_VISTA
} from "./actionTypes";
import {
  fetchObtenirIndrets,
  fetchObtenirIndretsLlistat,
  fetchObtenirDadesIndret,
  fetchIndretIntroduccioCrearIndret,
  fetchIndretIntroduccioEditarIndret
} from "./consultesServidor";

import {
  formulariNoShanModificatDades,
  obtenirErrorsDadesIndret,
  hiHaErrorsDadesFormulari
} from "../utils/formularis";

import {
  crearNotificacioDadesNoCanviades,
  crearNotificacioFormulariFaltenDadesObligatories,
  crearNotificacioSuccess,
  crearNotificacioError
} from "../utils/notificacio";
import { errorConsultaServidor } from "./error";
import { rutaIndrets } from "../routes";

const obtenirFormData = (fotosCreades, dades) => {
  let dadesAEnviar = new FormData();
  fotosCreades.forEach(imatge => {
    dadesAEnviar.append("fotosCreades", imatge.fitxer);
  });

  delete dades.id;
  delete dades.fotos;
  delete dades.motiuBaixa;
  delete dades.dataBaixa;
  delete dades.nomObservador;
  delete dades.fotosCreades;

  dadesAEnviar.append("dades", JSON.stringify(dades));
  return dadesAEnviar;
};

const indretIntroduccioMostrarErrors = () => ({
  type: INDRET_INTRODUCCIO_MOSTRAR_ERRORS
});

const indretIntroduccioEnviarFormulariEnCurs = () => ({
  type: INDRET_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS
});

const indretIntroduccioEnviarFormulariFinalitzada = () => ({
  type: INDRET_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
});

export const obtenirIndrets = () => {
  return {
    type: OBTENIR_INDRETS,
    promise: fetchObtenirIndrets()
  };
};

export const getDadesIndretSeleccionat = idIndret => {
  return {
    type: OBTENIR_INDRET_ID,
    payload: idIndret
  };
};

export const obtenirDadesIndret = idIndret => {
  return {
    type: OBTENIR_DADES_INDRET,
    promise: fetchObtenirDadesIndret(idIndret)
  };
};

export const obtenirIndretsLlistat = () => {
  return {
    type: OBTENIR_INDRETS_LLISTAT,
    promise: fetchObtenirIndretsLlistat()
  };
};

export const esborrarIndretSeleccionat = () => {
  return {
    type: ESBORRAR_INDRET_SELECCIONAT,
    payload: null
  };
};

export const indretIntroduccioModificarCamp = (idCamp, valor) => {
  return {
    type: INDRET_INTRODUCCIO_MODIFICAR_CAMP,
    idCamp,
    valor
  };
};

/**
 * S'afegeix una foto al llistat de fotos creades
 * @param foto {Object}
 * @returns {{type, foto}|*}
 */
export const indretIntroduccioFotosCrearFoto = foto => {
  return {
    type: INDRET_INTRODUCCIO_FOTOS_CREAR_FOTO,
    foto
  };
};

/**
 * S'afegeix una foto al llistat de fotos eliminades
 * @param foto {Object}
 * @returns {{type, foto}|*}
 */
export const indretIntroduccioFotosEliminarFoto = foto => {
  return {
    type: INDRET_INTRODUCCIO_FOTOS_ELIMINAR_FOTO,
    foto
  };
};

/**
 * S'elimina la foto amb l'índex especificat del llistat de fotos creades
 * @param indexFoto {Object}
 * @returns {{type, indexFoto}|*}
 */
export const indretIntroduccioFotosDescartarFoto = indexFoto => {
  return {
    type: INDRET_INTRODUCCIO_FOTOS_DESCARTAR_FOTO,
    indexFoto
  };
};

export const indretIntroduccioDescartarCanvis = () => {
  return {
    type: INDRET_INTRODUCCIO_DESCARTAR_CANVIS
  };
};

export const indretIntroduccioEnviarFormulari = routerHistory => {
  return (dispatch, getState) => {
    const estat = getState();

    const idIndret = estat.indrets.dades.idIndretSeleccionat;
    const esNouIndret = idIndret ? false : true;
    const dadesOriginals = estat.indrets.formulari.originals;
    const dadesEditades = estat.indrets.formulari.editades;
    const fotos = estat.indrets.formulari.fotos;

    const errors = obtenirErrorsDadesIndret(dadesEditades, esNouIndret);
    const hiHaError = hiHaErrorsDadesFormulari(errors);
    if (hiHaError.length > 0) {
      dispatch(indretIntroduccioMostrarErrors());
      crearNotificacioFormulariFaltenDadesObligatories();
      return;
    }

    let promesa;
    const rutaRedireccionamentSiInsercioOk = rutaIndrets;
    let missatgeNotificacioExit;
    let missatgeNotificacioError;
    const nomIndret = dadesEditades.nom || "";

    if (idIndret) {
      let dadesTransformades = Object.assign({}, dadesEditades);
      const shanEliminatFotos = fotos.eliminades && fotos.eliminades.length > 0;
      const shanCreatFotos = fotos.creades && fotos.creades.length > 0;

      if (shanEliminatFotos) {
        dadesTransformades.fotosEliminades = fotos.eliminades;
      }
      if (shanCreatFotos) {
        dadesTransformades.fotosCreades = fotos.creades;
      }

      if (formulariNoShanModificatDades(dadesOriginals, dadesTransformades)) {
        crearNotificacioDadesNoCanviades();
        return;
      }

      dispatch(indretIntroduccioEnviarFormulariEnCurs());

      const dadesAEnviar = obtenirFormData(fotos.creades, dadesTransformades);

      promesa = fetchIndretIntroduccioEditarIndret(idIndret, dadesAEnviar);
      missatgeNotificacioExit = `Indret "${nomIndret}" editat correctament`;
      missatgeNotificacioError = "Error editant l'indret";
    } else {
      // creant observador: Indret -> fotos
      if (formulariNoShanModificatDades(dadesOriginals, dadesEditades)) {
        crearNotificacioDadesNoCanviades();
        return;
      }
      dispatch(indretIntroduccioEnviarFormulariEnCurs());
      let dadesTransformades = Object.assign({}, dadesEditades);
      delete dadesTransformades.canvis;
      const dadesAEnviar = obtenirFormData(fotos.creades, dadesTransformades);

      promesa = fetchIndretIntroduccioCrearIndret(dadesAEnviar);

      missatgeNotificacioExit = `Indret "${nomIndret}" creat correctament`;
      missatgeNotificacioError = "Error creant l'indret";
    }

    return promesa.then(
      result => {
        dispatch(indretIntroduccioEnviarFormulariFinalitzada());
        if (result && result.msg) {
          return crearNotificacioError(result.msg);
        }
        crearNotificacioSuccess(missatgeNotificacioExit);
        routerHistory.push(rutaRedireccionamentSiInsercioOk);
      },
      errorServidor => {
        dispatch(indretIntroduccioEnviarFormulariFinalitzada());
        dispatch(
          errorConsultaServidor(errorServidor, missatgeNotificacioError)
        );
      }
    );
  };
};

export const inicialitzarIndret = () => {
  return {
    type: INDRET_INICIALITZAR,
    payload: null
  };
};

export const canviTextCercaVista = (textCerca, columnaCerca) => {
  return {
    type: CANVI_TEXT_CERCA_VISTA,
    payload: { textCerca: textCerca, columnaCerca: columnaCerca }
  };
};
